import { useState } from "react";
import { C, font } from "../theme";
import { Button } from "./Button";
import { useSession } from "../lib/session/SessionContext";

export function TenantSwitcher() {
  const { tenants, activeTenantId, activeTenant, switchTenant, error } = useSession();
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);

  const pick = async (tenantId: string) => {
    setBusy(true);
    await switchTenant(tenantId);
    setBusy(false);
    setOpen(false);
  };

  return (
    <div style={{ position: "relative", fontFamily: font }}>
      <Button
        variant="outline"
        onClick={() => setOpen(o => !o)}
        disabled={busy}
        style={{ fontSize: 11.5, padding: "6px 12px" }}
      >
        {busy ? "Trocando..." : "Trocar CT"}
      </Button>
      {open && (
        <div
          style={{
            position: "absolute",
            right: 0,
            top: "calc(100% + 6px)",
            background: C.white,
            border: `1px solid ${C.faint}`,
            borderRadius: 10,
            boxShadow: "0 8px 24px rgba(0,0,0,.08)",
            padding: 8,
            minWidth: 240,
            zIndex: 20,
          }}
        >
          <div style={{ fontSize: 10.5, letterSpacing: 1, color: C.light, fontWeight: 700, padding: "4px 8px 8px" }}>
            {activeTenant ? `CT ativo: ${activeTenant.name}` : "Seus CTs"}
          </div>
          {tenants.map(t => (
            <button
              key={t.tenantId}
              onClick={() => pick(t.tenantId)}
              disabled={busy || t.tenantId === activeTenantId}
              style={{
                fontFamily: font,
                display: "block",
                width: "100%",
                textAlign: "left",
                background: t.tenantId === activeTenantId ? C.limeSoft : "none",
                border: "none",
                borderRadius: 8,
                padding: "8px 10px",
                cursor: t.tenantId === activeTenantId ? "default" : "pointer",
              }}
            >
              <div style={{ fontSize: 13, fontWeight: 600, color: C.ink }}>{t.name}</div>
              <div style={{ fontSize: 11, color: C.light }}>{t.roleSlug}</div>
            </button>
          ))}
          {error && (
            <div style={{ fontSize: 11.5, color: C.red, padding: "6px 8px" }}>{error}</div>
          )}
        </div>
      )}
    </div>
  );
}
